import { render, staticRenderFns } from "./hotReqsType.vue?vue&type=template&id=241da3b5&scoped=true&"
import script from "./hotReqsType.vue?vue&type=script&lang=js&"
export * from "./hotReqsType.vue?vue&type=script&lang=js&"
import style0 from "./hotReqsType.vue?vue&type=style&index=0&id=241da3b5&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241da3b5",
  null
  
)

export default component.exports